module.exports = __webpack_public_path__ + "img/icon-navigation-drop-down.4db4b458.svg";